import { useMemo } from 'react';

import { createBrandedMaskConfig } from '../utils';
import { MaskConfig } from '../types';

export type CustomMaskProps = {
    /**
     * Параметр кастомной маски, может быть регуляркой, массивом регулярок или функцией, работающей с введенным value
     *
     * Должно быть мемоизировано при помощи useMemo, или вынесено вне компонента
     */
    mask: MaskConfig['maskitoOptions']['mask'];
    /**
     * Препроцессоры кастомной маски
     *
     * Должно быть мемоизировано при помощи useMemo, или вынесено вне компонента
     */
    preprocessors?: MaskConfig['maskitoOptions']['preprocessors'];
    /**
     * Постпроцессоры кастомной маски
     *
     * Должно быть мемоизировано при помощи useMemo, или вынесено вне компонента
     */
    postprocessors?: MaskConfig['maskitoOptions']['postprocessors'];
    /**
     * Плагины кастомной маски
     *
     * Должно быть мемоизировано при помощи useMemo, или вынесено вне компонента
     */
    plugins?: MaskConfig['maskitoOptions']['plugins'];
    /**
     * Функция, трансформирующая к чистому значению без маски
     *
     * Должно быть мемоизировано при помощи useMemo, или вынесено вне компонента
     */
    transformToUnmasked: MaskConfig['transformToUnmasked'];
};
/**
 * Хук кастомных масок
 *
 * Пример использования
 * const phoneMaskProps: CustomMaskProps = useMemo(() => {
 *      return {
 *          mask: ['+', '7', ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
 *          transformToUnmasked: (value: string) => {
 *              return value.replace(/[^\d\+\*]/g, '');
 *          },
 *      };
 *  }, []);
 */
export const useCustomMask = (props: CustomMaskProps): MaskConfig => {
    const { mask, transformToUnmasked, postprocessors = [], preprocessors = [], plugins = [] } = props;

    const result = useMemo(
        () =>
            createBrandedMaskConfig({
                transformToUnmasked,
                maskitoOptions: {
                    mask,
                    postprocessors,
                    preprocessors,
                    plugins,
                },
            }),
        [mask, plugins, postprocessors, preprocessors, transformToUnmasked],
    );

    return result;
};
